import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { TypeRamp } from "../../typography";
import { ModalType } from "../types";

interface StyledModalTitleProps {
    type: ModalType;
}

function omitStyledModalTitleProps(propName: string) {
    switch (propName) {
        case "type":
            return false;
        default:
            return true;
    }
}

export const StyledModalTitle = styled(TypeRamp, {
    shouldForwardProp: omitStyledModalTitleProps,
})<StyledModalTitleProps>`
    display: flex;
    align-items: center;
    margin: 0;

    ${(props) =>
        props.type === "simple"
            ? `
      padding: ${sizes.xLarge}px ${sizes.xSmall}px 0px ${sizes.xLarge}px;
      `
            : `
      padding: ${sizes.xLarge}px ${sizes.xSmall}px ${sizes.large}px ${sizes.xLarge}px;
      `}

    flex: 1 1 auto;
    // To align the icon and text
    align-items: flex-start;
    min-width: 0; // to support eliding single-line headers
`;
